import styled, { css } from 'styled-components';
import { Form } from 'synapsefi-dev-ui';
import account_grid from './account_grid.style';
import account_form from './account_form.style';
import { CUSTOM } from '../constants/VendorNames';

export const StyledForm = styled(Form)`
    margin: 0px;
    padding: 20px 5px 0px 20px;
    width: 553px;

    ${props => props.vendor === CUSTOM ?
        css`
            height: 478px;` :
        css`
            height: auto;
        `
    }

    ${props => !props.isForeign ? css`
        .form-conversion {
            display: none;
        } ` :
        css`
            .form-conversion {
            display: grid;
            }
        `
    }

    position: initial;
    grid-template-columns: repeat(6,4%) 0% repeat(5,4%) 4%;
    grid-column-gap: 4%;
    ${account_grid}
    ${account_form}
`;